import React, { useEffect, useState } from "react";
import s from "./Course.less";
import { setFieldsConfig } from "./options";
import Modal from "~/shared/ui/Fields/Modal";
import EditCourseMenu from "../EditCourseMenu";
import CourseCard from "./CourseCard";
import { useGetFilteredCoursesForSelect } from "../../hooks";
const Course = ({
  course,
  control,
  handleDeleteCourse,
  handleChangeCourse,
  handleOnChangeCourse,
  courseStatusError,
  watch,
  usedCoursesId,
  levelId,
  level,
  refetch,
}) => {
  const [isMoreDetails, setIsMoreDetails] = useState(false);
  const [isEditCourse, setIsEditCourse] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [certificateValidityPeriod, setCertificateValidityPeriod] = useState(
    course.certificateValidityPeriod
  );
  const fieldsConfig = setFieldsConfig({ course });

  const {
    filteredCourses: availableCourses,
    intersectionObserverCourseId: intersectionObserver,
    searchTextCourseId: searchText,
  } = useGetFilteredCoursesForSelect({ usedCoursesId, levelId });

  const handleShowMoreDetails = () => {
    setIsMoreDetails(!isMoreDetails);
  };

  const handleSaveCourse = () => {
    if (!courseStatusError) {
      handleChangeCourse(course.id);
      setIsEditCourse(false);
    }
    handleCloseModal();
  };

  const handleCancelChanges = () => {
    setIsEditCourse(false);
    handleCloseModal();
  };
  const handleCloseModal = () => setIsOpenModal(false);
  const handleOpenModal = () => setIsOpenModal(true);

  const currentCourseWatcher = watch(`${course.id}course`);

  useEffect(() => {
    if (currentCourseWatcher && course.id !== currentCourseWatcher.value) {
      setCertificateValidityPeriod(
        currentCourseWatcher.certificateValidityPeriod
      );
    }
  }, [currentCourseWatcher]);

  return (
    <li className={s.item}>
      <CourseCard
        course={course}
        certificateValidityPeriod={certificateValidityPeriod}
        setIsEditCourse={setIsEditCourse}
        setIsMoreDetails={setIsMoreDetails}
        handleDeleteCourse={handleDeleteCourse}
        isMoreDetails={isMoreDetails}
        handleShowMoreDetails={handleShowMoreDetails}
        handleCloseModal={handleCloseModal}
        handleOpenModal={handleOpenModal}
        fieldsConfig={fieldsConfig}
        level={level}
        refetch={refetch}
      />
      {isEditCourse && (
        <Modal
          isOpen={isOpenModal}
          actionClose={handleCloseModal}
          title={"Редактирование курса"}
        >
          <EditCourseMenu
            isEditCourse={isEditCourse}
            course={course}
            control={control}
            availableCourses={availableCourses}
            searchText={searchText}
            intersectionObserver={intersectionObserver}
            handleOnChangeCourse={handleOnChangeCourse}
            certificateValidityPeriod={certificateValidityPeriod}
            courseStatusError={courseStatusError}
            handleSaveCourse={handleSaveCourse}
            handleCancelChanges={handleCancelChanges}
          />
        </Modal>
      )}
    </li>
  );
};

export const MemoizedCourse = React.memo(Course);
